"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Deprecation Notice: Remove this code class at next Major Breaking Release
// Remove prop `navigation`
// Remove propType `navigation`
const getListClassNames = list_type => {
  let ulStyle = '';
  let liStyle = '';
  switch (list_type) {
    /* istanbul ignore next */
    case 'navigation':
      ulStyle = 'mm-list-group--quick-actions';
      break;
    case 'quickActions':
      ulStyle = 'mm-list-group--quick-actions';
      break;
    default:
      ulStyle = 'list-group list-group-flush';
      liStyle = 'list-group-item';
      break;
  }
  return {
    ulStyle,
    liStyle
  };
};
const ListGroupItem = _ref => {
  let {
    children,
    liStyle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: liStyle
  }, children);
};
ListGroupItem.displayName = 'ListGroup.ListGroupItem';
ListGroupItem.propTypes = {
  /**
   * The contents of the List Item.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The style of the List Item.
   */
  liStyle: _propTypes.default.string
};

/**
 * List Group is a component that renders a list of content or a list of quick actions.
 */

const ListGroup = _ref2 => {
  let {
    children,
    variant
  } = _ref2;
  let listStyles = {};
  listStyles = getListClassNames(variant);
  const listItemsWithVariants = _react.default.Children.map(children, child => /*#__PURE__*/_react.default.cloneElement(child, {
    liStyle: listStyles.liStyle
  }));
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: listStyles.ulStyle
  }, listItemsWithVariants);
};
ListGroup.ListGroupItem = ListGroupItem;
ListGroup.propTypes = {
  /**
   * The contents of this list group.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The variant of this List Group. One of 'flush' or 'quickActions'.
   */
  variant: _propTypes.default.oneOf(['flush', 'quickActions'])
};
ListGroup.defaultProps = {
  variant: 'flush'
};
var _default = exports.default = ListGroup;